import { render } from "./IdentityComponent.vue?vue&type=template&id=db47915e"
import script from "./IdentityComponent.vue?vue&type=script&lang=js"
export * from "./IdentityComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__